/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Dashboard
 * (C) Copyright IBM Corp. 2020, 2022
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'underscore',
	'jquery',
	'../../../../widgets/livewidget/nls/StringResources',
	'react-dom',
	'react',
	'@ba/ba-ui-carbon-toolkit',
	'prop-types',
	'./DrillThroughDefinitionSelectMenu'
], function (_, $, StringResources, ReactDOM, React, Toolkit, PropTypes, DrillThroughDefinitionSelectMenu) {

	const { Container, ProgressIndicator, SVGIcon, FlexItem, Label, List } = Toolkit;

	const KEY_CODES = {
		ENTER: 13
	};


	class DrillThroughDefinitionPrommpts extends React.Component {

		constructor(props) {
			super(props);
			this.noPromptHeading = StringResources.get('noPrompt');
			this.noPromptDetails = StringResources.get('drillThroughDefinitionNoParameter');
			this.reportIcon = this.props.iconsFeature.getIcon('reportIcon');
			this.currentApplicationIcon = this.props.currentApplicationName === 'story' ? this.props.iconsFeature.getIcon('storyIcon') : this.props.iconsFeature.getIcon('dashboardIcon');
			this.chevronLeftIcon = this.props.iconsFeature.getIcon('common-chevron_left');
			this.selectedIndexOfRows = [];
			this.state = {
				rowIdToShowMenu: '-1',
				selectedIndexOfRows:this.selectedIndexOfRows
			};
			this.selectColumnText = StringResources.get('drillthrough_selectColumn');
		}

		_renderNoPrompt(){
			return (
				<Container className='dtEditTable dtNoPromptTable'>
					<Container className="dtNoPrompt">
						<Container className= 'dtNoPromptIconContainer'>
							<SVGIcon
								iconId='visualizations-drillthrough_no_prompt_16'
								className='dtIcon'
							/>
						</Container>
						<Container className='noPromptDetails'>
							<h3 aria-label={this.noPromptHeading} title={this.noPromptHeading}> {this.noPromptHeading} </h3>
							<p aria-label={this.noPromptDetails} title={this.noPromptDetails} tabIndex={0} > {this.noPromptDetails} </p>
						</Container>
					</Container>
				</Container>
			);
		}

		_renderLoading(){
			return (<Container className='dtEditTable dtLoading'>
				<ProgressIndicator tabIndex={0} size='normal' />
			</Container>);
		}


		_renderHeaderColumn(icon, title){
			return (
				<FlexItem className = 'dtEditTableCol'>
					<Container className = 'dtTableHeaderTitle'>
						<SVGIcon
							iconId={icon.id}
							className='dtIcon'
						/>
						<Label ellipsis= {true} type='caption' aria-label={title} label={title} tabIndex={0}></Label>
					</Container>
				</FlexItem>);
		}

		_renderPromptHeader(){
			return (<Container className='dtEditTableHeader'>
				{this._renderHeaderColumn(this.reportIcon, this.props.parametersTitle)}
				{this._renderHeaderColumn(this.currentApplicationIcon, this.props.metadataTitle)}
			</Container>);
		}

		_renderSelectMenu(rowId){
			if (rowId === this.state.rowIdToShowMenu){
				return (<DrillThroughDefinitionSelectMenu
					noMappingText = { this.props.noMappingText }
					rowId = {this.state.rowIdToShowMenu}
					getRow = {this.props.getRow}
					onSelectMenuOpened = {this._onSelectMenuOpened.bind(this)}
					onSelectValue = {this._onSelectValue.bind(this)}
					onClose = {this._closeSelectMenu.bind(this)}
					iswithinVerticalBounds = {this._iswithinVerticalBounds.bind(this)}
				/>);
			}else{
				return null;
			}
		}

		_renderPromptRow(index){
			const item = this.props.getRow(index);
			const selected = this.state.selectedIndexOfRows.length !== 0 ? this.state.selectedIndexOfRows[index] >= 0 : item.state.selectedIndex  >= 0;
			const rowsItemClassName = selected ? 'dtEditTableRowsItem mapped': 'dtEditTableRowsItem';
			const labelClassName = selected ? 'dt-checked': 'dt-checked hidden';
			const caption = item.caption;
			const checkIconClassName = `dtIcon dt-checkbox-icon row_checkIcon row_checkIcon_${index}`;
			const value = selected ? item.state.values[item.state.selectedIndex]:this.selectColumnText;
			const dropDownToggled = index.toString() === this.state.rowIdToShowMenu;
			let dtDropDownIconClassName = 'dtDropDownIcon dtIcon';
			dtDropDownIconClassName += dropDownToggled ? ' open': '';
			return (
				<Container className = {rowsItemClassName}>
					<FlexItem className = 'dtEditTableCol'>
						<div tabIndex='0' aria-label={caption}></div>
						<span className={checkIconClassName}>
							<label className={labelClassName} ></label>
						</span>
						<span title={caption} className='dtTableHeaderTitle'>
							{caption}
						</span>
					</FlexItem>
					<FlexItem className = 'dtEditTableCol selectColoumns'>
						<Container className ='dtSelect'>
							<Container aria-activedescendant='dt-activedescendant' tabindex='0' className='dtColDropdown' data-rowId={index}  aria-expanded={dropDownToggled} onClick={this._toggleSelectMenu.bind(this)} onKeyDown={this._onDropDownKeydown.bind(this)}>
								<Label className = 'dtColDropdownLabel' aria-label={value} label={value} />
								<Container className={dtDropDownIconClassName}>
									<SVGIcon icon={this.chevronLeftIcon} className='svgIcon'></SVGIcon>
								</Container>
							</Container>
							{this._renderSelectMenu(index.toString())}
						</Container>
					</FlexItem>
				</Container>
			);
		}

		_renderPromptRows(){
			return  (<List
				length={this.props.rowSize}
				itemRenderer={this._renderPromptRow.bind(this)}
				className='dtEditTableRows'
			/>);
		}

		_renderPrompt(){
			return (<Container className='dtEditTable'>
				{this._renderPromptHeader()}
				{this._renderPromptRows()}
			</Container>);
		}

		render() {
			if (this.props.isLoading){
				return this._renderLoading();
			} else if(!this.props.rowSize && this.props.isReportPerspective){
				return this._renderNoPrompt();
			}else if(this.props.isReportPerspective){
				return this._renderPrompt();
			}
			return (null);
		}

		/*
		* Toggle the select menu drop down
		*/
		_toggleSelectMenu(event){
			const $currentTarget = $(event.currentTarget);
			const $selectNode = $currentTarget.parent();
			if($currentTarget.hasClass('dtColDropdown') && $selectNode.find('.dtSelectList').length){
				this._closeSelectMenu();
			}else if($currentTarget.hasClass('dtColDropdown')) {
				this._openSelectMenu(event);
			}
		}

		/*
		* Close the select menu dropdown
		*/
		_closeSelectMenu(){
			if(this.state.rowIdToShowMenu !== '-1'){
				this.setState( { rowIdToShowMenu: '-1' } );
			}
		}

		_onSelectMenuOpened(selectMenuRef){

			const $node = $(selectMenuRef);
			this.$selectNode = $node.parent();
			$node.on('mouseover mousemove mousein mouseout',function(event){
				$node.find('span').removeClass('noPsuedoHover psuedoHover');
				$(event.target).addClass('psuedoHover');
			});

			$node.show();

			const $list =  this.$selectNode.find('.dtSelectList');
			const $selected =  $list.find('span.dtSelected').addClass('psuedoHover');
			if($selected.length){
				if(!this._iswithinVerticalBounds($selected, $list)){
					$selected.get(0).scrollIntoView();
				}
			}
			if ($list.length){
				$list.get(0).focus();
				this._onDropDownKeydown_bind = this._onDropDownKeydown.bind(this, $list);
				$list.keydown(this._onDropDownKeydown_bind);
			}

		}

		/*
		* Open the select menu dropdown
		*/
		_openSelectMenu(event){
			event.preventDefault();
			event.stopPropagation();
			var rowId = event.currentTarget.dataset.rowid;
			this.setState({ rowIdToShowMenu: rowId });

		}

		/**
		* Select value callback
		*/
		_onSelectValue(payload){
			this._selectValue(payload);
			this._closeSelectMenu();
		}

		/**
		* Select value callback helper
		*/
		_selectValue(payload){

			const rowId = payload.rowId;
			const selectedIndex = payload.index -1;
			this.props.handlers.onValueSelected(rowId,  selectedIndex);
			this.selectedIndexOfRows = [];
			for (let i = 0; i < this.props.rowSize; i++ ){
				const item = this.props.getRow(i);
				this.selectedIndexOfRows.push(item.state.selectedIndex);
			}

			this.setState(
				{ selectedIndexOfRows: this.selectedIndexOfRows } );
		}

		/**
		* Keydown handler when select drop down is focus
		*/
		_onDropDownKeydown(event){

			const isEnter = event.which === KEY_CODES.ENTER || event.keyCode === KEY_CODES.ENTER;
			if (isEnter){
				this._toggleSelectMenu(event);
			}
		}

		/**
		* Check is an element is within the bound of another
		*/
		_iswithinVerticalBounds($childElement, $containerElem){
			var containerRect = $containerElem.get(0).getBoundingClientRect();
			var childRect = $childElement.get(0).getBoundingClientRect();

			return childRect.top >= containerRect.top
				&& childRect.bottom <= containerRect.bottom;
		}

	}

	DrillThroughDefinitionPrommpts.propTypes = {
		isLoading: PropTypes.bool,
		iconsFeature: PropTypes.object,
		rowSize: PropTypes.number,
		isReportPerspective: PropTypes.bool,
		currentApplicationName: PropTypes.string,
		parametersTitle:PropTypes.string,
		metadataTitle:PropTypes.string,
		getRow:PropTypes.func,
		noMappingText:PropTypes.string,
		handlers: PropTypes.object
	};
	return DrillThroughDefinitionPrommpts;
});

